export default {
  project: {
    name: 'String',
    password: 'String',
    emailAddress: 'String',
    displayName: 'String',
  },
  property: {
    key: 'value',
  },
}
